import { render, staticRenderFns } from "./EditFieldMaterial.vue?vue&type=template&id=1d96e7ad&scoped=true"
import script from "./EditFieldMaterial.vue?vue&type=script&lang=js"
export * from "./EditFieldMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d96e7ad",
  null
  
)

export default component.exports